import TRPC from '@/utils/trpc';

// 查询配置
const getDetail = function (data) {
  return TRPC.newRequest('bffares/querypage', data);
};

// 查询预览配置
const getPreviewDetail = function (data) {
  return TRPC.newRequest('bffares/previewpage', data);
};

// 查询配置 ByConfID
const getDetailByConfID = function (data) {
  return TRPC.newRequest('bffares/querypagebyconfid', data);
};

// 查询预览配置 ByConfID
const getPreviewDetailByConfID = function (data) {
  return TRPC.newRequest('bffares/previewpagebyconfid', data);
};

export default {
  getDetail,
  getPreviewDetail,
  getDetailByConfID,
  getPreviewDetailByConfID,
};
